

import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import NumberFormat from "@/modules/NumberCore/NumberFormat";

const secondsInMinute = 60;

@Component
export default class IBCountdown extends Vue {

	@Prop({ type: String, default: 'span' })
	readonly tagName!: string

	@Prop({ type: Number, default: secondsInMinute })
	readonly timeInSeconds!: number

	remainingTimeInSeconds: number = 0

	secondsInMinute: number = secondsInMinute

	intervalInSeconds: number = 1

	intervalId: number = 0

	mounted() {
		this.startCountdown();
	}

	beforeDestroy() {
		this.stopCountdown();
	}

	startCountdown() {
		this.stopCountdown();

		this.remainingTimeInSeconds = this.timeInSeconds;

		this.intervalId = setInterval(() => {
			this.remainingTimeInSeconds -= this.intervalInSeconds;

			(this.remainingTimeInSeconds <= 0)
				&& this.stopCountdown();
		}, this.intervalInSeconds * 1000);

		this.emitStart();
	}

	stopCountdown() {
		if (!this.intervalId) return;

		clearInterval(this.intervalId);
		this.emitEnd();
	}

	get minutes(): number {
		return Math.floor(this.remainingTimeInSeconds / this.secondsInMinute);
	}

	get seconds(): number {
		return this.remainingTimeInSeconds - (this.minutes * this.secondsInMinute);
	}

	get formattedMinutes(): string {
		return NumberFormat.withZero(this.minutes);
	}

	get formattedSeconds(): string {
		return NumberFormat.withZero(this.seconds);
	}

	@Watch('timeInSeconds')
	timeInSecondsChanged() {
		this.startCountdown();
	}

	@Emit('start')
	emitStart() {}

	@Emit('end')
	emitEnd() {}

}

